import { Badge } from "@/components/ui/badge";
import { PizzaEvaluationMetadata } from "@/api/custom-schema";
import { getComponentDetectionBadgeColor } from "@/lib/badge-utils";

const DetectedComponentsTinyView = ({
  metadata,
}: {
  metadata: PizzaEvaluationMetadata;
}) => {
  if (!metadata?.components_evaluation) {
    return null;
  }

  const { base_components, extras } = metadata.components_evaluation;

  const getBadgeStyle = (componentName: string) => {
    // Base component found as expected
    if (base_components.found?.includes(componentName)) {
      return getComponentDetectionBadgeColor("found");
    }
    // Base component is missing but expected
    if (base_components.missing?.includes(componentName)) {
      return getComponentDetectionBadgeColor("missing");
    }
    // Base component is non-detectable (implicit ingredients like sauce, cheese base)
    if (base_components.non_detectable?.includes(componentName)) {
      return getComponentDetectionBadgeColor("non_detectable");
    }
    // Extra component found as expected
    if (extras.found?.includes(componentName)) {
      return getComponentDetectionBadgeColor("found");
    }
    // Extra component is missing but expected
    if (extras.missing?.includes(componentName)) {
      return getComponentDetectionBadgeColor("missing");
    }
    // Extra component is non-detectable
    if (extras.non_detectable?.includes(componentName)) {
      return getComponentDetectionBadgeColor("non_detectable");
    }
    // Default for other components
    return "bg-muted text-muted-foreground border border-border";
  };

  // Get all components that should be displayed
  const allComponents = Array.from(
    new Set([
      ...(base_components.expected || []),
      ...(base_components.non_detectable || []),
      ...(extras.expected || []),
      ...(extras.non_detectable || []),
    ]),
  );

  return (
    <div className="flex flex-col my-4 gap-4">
      <div className="flex flex-wrap gap-2">
        {allComponents.map((componentName) => (
          <Badge
            key={componentName}
            className={`py-1 px-2 ${getBadgeStyle(componentName)}`}
          >
            {componentName.charAt(0).toUpperCase() + componentName.slice(1)}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default DetectedComponentsTinyView;
